import React, { FC, useMemo } from 'react';
import useLocalStorage from 'utils/hooks/useLocalStorage';
import { PostPreviewVariant } from '@kontentino/kontentino-post-previews';
import { usePostComposer } from 'app/modules/posts/modules/post/components/composer/PostComposerProvider';
import { getPostPreviewFromPostComposerForm } from 'components/posts/detail/composer/leftSection/Preview.utils';
import PostPreviewWithVariants from 'app/components/PostPreviewWithVariants';
import { BrowserStorage } from 'utils/browserStorage';
import PostsConfig from 'app/config/posts';
import { useUser } from 'modules/user/userSelector';

type Props = {};

const Preview: FC<Props> = () => {
  const { form, videoPlayerRef } = usePostComposer();
  const user = useUser();
  const [variant, setVariant] = useLocalStorage<PostPreviewVariant>(
    BrowserStorage.keys.Posts.PreviewVariant,
    'desktop',
  );

  const postPreviewContent = getPostPreviewFromPostComposerForm(form);

  return useMemo(
    () => (
      <PostPreviewWithVariants
        isDownloadAssetsHidden
        content={postPreviewContent}
        variant={variant}
        use12hourFormat={!user.useMeridianTime}
        onVariantChange={setVariant}
        videoPlayerRef={videoPlayerRef}
        videoPlayerId={PostsConfig.POST_COMPOSE_PREVIEW_VIDEO_PLAYER_ID}
        dataCy={{
          postText: 'post-form-preview-text',
          wrapper: 'post-form-preview',
        }}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      form.text,
      form.id,
      variant,
      form.attachments,
      form.type,
      form.subtype,
      form.page,
      videoPlayerRef,
    ],
  );
};

export default Preview;
